window.trackers = [
  {
    "name": "Piano Analytics",
    "description": "https://www.atinternet.com/de/unternehmen/datenschutz/",
    "techname": "atInternet"
  },
  {
    "name": "AGF/Nielsen-Messverfahren",
    "description": "https://priv-policy.imrworldwide.com/priv/browser/de/de/optout.html",
    "techname": "agfNielsen"
  },
  {
    "name": "Chartbeat",
    "description": "https://chartbeat.com/privacy/",
    "techname": "chartbeatOpt"
  }
];
